<template>
  <BaseForm
    ref="baseForm"
    :title="$t('models.auth.changePassword')"
    :data-object="passwords"
    :content-type="'user'"
    :has-error="!passwordsMatch"
    :error-message="errorMessage"
    :custom-submit="true"
    :on-custom-submit="changePassword"
    :column-width="'is-6 is-offset-2'"
  >
    <template #content>
      <v-text-field
        v-model.trim="passwords.old_password"
        prepend-inner-icon="mdi-lock-outline"
        :label="$t('models.auth.oldPassword')"
        type="password"
        color="primary"
        name="old_password"
        :rules="[rules.required]"
      >
      </v-text-field>

      <v-text-field
        v-model.trim="passwords.new_password1"
        prepend-inner-icon="mdi-lock-outline"
        color="primary"
        :label="$t('models.auth.newPassword')"
        type="password"
        name="new_password"
        :rules="[rules.required]"
      >
      </v-text-field>

      <v-text-field
        v-model.trim="passwords.new_password2"
        prepend-inner-icon="mdi-lock-outline"
        color="primary"
        :label="$t('models.auth.repeatPassword')"
        type="password"
        name="new_password2"
        :rules="[rules.required]"
      >
      </v-text-field>
    </template>
  </BaseForm>
</template>

<script setup lang="ts">
import { computed, Ref, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { apiClient } from '@/api/ApiClient'
import BaseForm from '@/components/common/BaseForm.vue'
import { i18n } from '@/lang/setup'
const router = useRouter()
const store = useStore()

const rules = {
  required: (value) => !!value || 'Feld muss ausgefüllt sein',
}

const baseForm: Ref<typeof BaseForm> = ref(null)
const passwords = ref({
  old_password: '',
  new_password1: '',
  new_password2: '',
})
const errorMessage = ref('')

function changePassword() {
  apiClient
    .changePassword(passwords.value, store.state.global.profileId)
    .then((response) => {
      router.push('/')
    })
    .catch((error) => {
      baseForm.value.handleError(error)
    })
}

const passwordsMatch = computed(() => {
  if (passwords.value.new_password1 === passwords.value.new_password2) {
    return true
  } else {
    if (
      passwords.value.new_password1 !== '' &&
      passwords.value.new_password2 !== ''
    ) {
      errorMessage.value = i18n.global.t('models.auth.passwordNoMatch')
      return false
    } else {
      return true
    }
  }
})
</script>

<style lang="scss" scoped></style>
